<template>
  <div class="lidaCard ledger-block">
    <ButtonTool v-if="$route.name != 'generalLedgerSearch'">
      <BreadcrumbLevel />
    </ButtonTool>
    <router-view></router-view>
    <BackBottom ></BackBottom>
    <BackTop :height="10" :right="85"></BackTop>
  </div>
</template>
<script>
import ButtonTool from '@/components/tool/ButtonTool.vue'
import BreadcrumbLevel from '@/components/tool/BreadcrumbLevel'
export default {
  name: "general-ledger",
  components: {
    ButtonTool,
    BreadcrumbLevel
  },
}
</script> 